import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { AircraftProfileAudit } from '../../+models/aircraft-profile-audit.model';

@Component({
  selector: 'sd-portal-aircraft-profile-audit-list',
  templateUrl: './aircraft-profile-audit-list.component.html',
  styleUrls: ['./aircraft-profile-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AircraftProfileAuditListComponent implements OnInit {
  @Input() aircraftProfileId: number;
  @Input() loading: boolean;
  @Input() aircraftProfileAudits: AircraftProfileAudit[];

  @Output() loadAircraftProfile = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadAircraftProfile.emit(this.aircraftProfileId);
  }

  onNextPage() {
    this.nextPage.emit(this.aircraftProfileId);
  }
}
